import {styled} from "@mui/material";
import { useWholesale } from "../../store/wholesale";
import { ButtonSwitch } from "./button-switch";
import l10n from "../../lib/l10n";
import { useUser } from "../../hooks/use-user";
import { useCallback } from "react";

const StyledCurrencyContainer = styled('div')`
  margin-left: 8px;
  &::after {
    content: '${l10n.currency_symbol}';
    display: inline;
  }
`;

export const ButtonWholesale = () => {
  const {setActive} = useWholesale();

  const onChange = useCallback((checked) => {
    setActive(checked);
  }, [setActive]);

  if (useUser().getRole('wholesale')) {
    return (
      <div style={{ pointerEvents: 'all' }}>
        <ButtonSwitch onChange={onChange}>
          <StyledCurrencyContainer />
        </ButtonSwitch>
      </div>
    );
  }

  return null;
};